// Lib
import { ThemeFile } from 'lib/context/ThemeContext';

export const ReviewsListTheme: ThemeFile = {
  aw: {
    classes: {},
  },
  rba: {
    classes: {
      reviewListWrapper: 'my-8',
      reviewList: 'border-t border-t-gray clear-both',
      review:
        'border-b border-b-gray max-[360px]:flex max-[360px]:flex-col max-[360px]:gap-y-xs max-[360px]:px-s max-[360px]:py-xs sm:flex sm:flex-col sm:px-m sm:py-xs md:grid md:grid-cols-[minmax(0,1fr)_minmax(260px,35%)] md:items-start md:gap-x-4 md:px-m md:py-s lg:grid-cols-[18%_1fr_25%] lg:gap-x-6 lg:gap-y-0 lg:items-center',
      ratingSection:
        'flex sm:flex-row gap-1 shrink-0 md:col-start-1 md:row-start-1 lg:mb-0 lg:justify-center lg:items-center lg:flex-col lg:pr-ml lg:self-center',
      ratingText:
        'font-sans font-medium sm:text-xs md:text-m md:text-center md:leading-l lg:text-center lg:text-xl',
      ratingStars:
        'inline-flex items-center leading-none gap-[2px] md:max-w-fit lg:mb-0 lg:ml-auto lg:mr-auto',
      reviewSection:
        'flex flex-col md:justify-center lg:justify-center min-w-0 md:col-start-1 md:row-start-2 lg:col-start-2 lg:row-auto lg:self-center',
      reviewSectionNoProductImages:
        'flex flex-col md:justify-center min-w-0 md:col-start-1 md:row-start-2 md:pt-xxs lg:col-start-2 lg:row-auto lg:self-center',
      reviewNameSection: 'sm:mt-xxxs font-sans',
      reviewName: 'font-medium md:text-xs md:leading-m',
      reviewLocation: 'font-normal text-dark-gray md:text-body md:leading-m',
      reviewDateSection: 'sm:mt-xxxs md:mt-xxxs',
      reviewDate: 'font-normal md:text-body md:leading-m',
      reviewText:
        'font-normal text-dark-gray sm:mt-xxxs md:mt-xxxs md:text-body md:leading-m lg:max-w-[592px]',
      reviewTextNoProductImages:
        'font-normal text-dark-gray sm:mt-xxxs md:mt-xxxs md:text-body md:leading-m',
      productSection:
        'flex flex-col max-[360px]:mt-s sm:mt-xs md:mt-0 md:self-stretch md:pl-0 md:col-start-2 md:row-start-1 md:row-span-2 md:text-xxs md:leading-s shrink-0 lg:col-start-3 lg:row-auto lg:justify-center lg:self-center',
      productSectionHeader: 'font-bold',
      productSectionImages: 'sm:mt-xs carousel-slider',
      productSectionImageWrapper: 'md:mt-s',
      productSectionProductName:
        'ml-auto mr-auto max-w-fit md:mt-xxxs max-[360px]:text-xxs text-center sm:text-xxs',
      productImage: 'ml-auto mr-auto max-w-fit',
      loadMoreContainer: 'max-w-fit ml-auto mr-auto mt-ml',
      loadMoreButton: 'border border-black p-s font-bold text-body',
      loadMoreText: 'mr-xxs',
    },
  },
};
